import {
  actionTextConversion
} from "./chunk.CD3DSRSX.js";
import {
  OverlayComponent,
  overlayStyles
} from "./chunk.PXGMVSIO.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  hasSlot
} from "./chunk.Z2CDDKXX.js";
import {
  watch
} from "./chunk.HBM5K2JV.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/components/tooltip/tooltip.ts
import { html } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/tooltip/tooltip.styles.ts
import { css } from "lit";
var tooltip_styles_default = css`
	${component_styles_default}
	${theme_styles_default}
	${overlayStyles}

	.tooltip__inner {
		display: inline-flex;
	}

	.tooltip {
		max-width: var(--yotpo-tooltip-max-width);
		border-radius: var(--yotpo-tooltip-border-radius);
		background-color: var(--yotpo-tooltip-background-color);
		font-family: var(--yotpo-tooltip-font-family);
		font-size: var(--yotpo-tooltip-font-size);
		font-weight: var(--yotpo-tooltip-font-weight);
		line-height: var(--yotpo-tooltip-line-height);
		color: var(--yotpo-tooltip-color);
		padding: var(--yotpo-tooltip-padding);
		box-shadow: var(--yotpo-tooltip-shadow);
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		text-align: start;
	}

	.tooltip:after {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
	}

	.overlay__positioner[data-popper-placement^='top'] .tooltip {
		transform-origin: bottom;
	}

	.overlay__positioner[data-popper-placement^='bottom'] .tooltip {
		transform-origin: top;
	}

	.overlay__positioner[data-popper-placement^='left'] .tooltip {
		transform-origin: right;
	}

	.overlay__positioner[data-popper-placement^='right'] .tooltip {
		transform-origin: left;
	}

	/* Arrow + bottom */
	.overlay__positioner[data-popper-placement^='bottom'] .tooltip:after {
		bottom: 100%;
		left: calc(50% - var(--yotpo-tooltip-arrow-size));
		border-bottom: var(--yotpo-tooltip-arrow-size) solid var(--yotpo-tooltip-background-color);
		border-left: var(--yotpo-tooltip-arrow-size) solid transparent;
		border-right: var(--yotpo-tooltip-arrow-size) solid transparent;
		box-shadow: var(--yotpo-tooltip-shadow);
	}

	.overlay__positioner[data-popper-placement='bottom-start'] .tooltip:after {
		left: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	.overlay__positioner[data-popper-placement='bottom-end'] .tooltip:after {
		right: var(--yotpo-tooltip-arrow-start-end-offset);
		left: auto;
	}

	/* Arrow + top */
	.overlay__positioner[data-popper-placement^='top'] .tooltip:after {
		top: 100%;
		left: calc(50% - var(--yotpo-tooltip-arrow-size));
		border-top: var(--yotpo-tooltip-arrow-size) solid var(--yotpo-tooltip-background-color);
		border-left: var(--yotpo-tooltip-arrow-size) solid transparent;
		border-right: var(--yotpo-tooltip-arrow-size) solid transparent;
		box-shadow: var(--yotpo-tooltip-shadow);
	}

	.overlay__positioner[data-popper-placement='top-start'] .tooltip:after {
		left: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	.overlay__positioner[data-popper-placement='top-end'] .tooltip:after {
		right: var(--yotpo-tooltip-arrow-start-end-offset);
		left: auto;
	}

	/* Arrow + left */
	.overlay__positioner[data-popper-placement^='left'] .tooltip:after {
		top: calc(50% - var(--yotpo-tooltip-arrow-size));
		left: 100%;
		border-left: var(--yotpo-tooltip-arrow-size) solid var(--yotpo-tooltip-background-color);
		border-top: var(--yotpo-tooltip-arrow-size) solid transparent;
		border-bottom: var(--yotpo-tooltip-arrow-size) solid transparent;
		box-shadow: var(--yotpo-tooltip-shadow);
	}

	.overlay__positioner[data-popper-placement='left-start'] .tooltip:after {
		top: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	.overlay__positioner[data-popper-placement='left-end'] .tooltip:after {
		top: auto;
		bottom: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	/* Arrow + right */
	.overlay__positioner[data-popper-placement^='right'] .tooltip:after {
		top: calc(50% - var(--yotpo-tooltip-arrow-size));
		right: 100%;
		border-right: var(--yotpo-tooltip-arrow-size) solid var(--yotpo-tooltip-background-color);
		border-top: var(--yotpo-tooltip-arrow-size) solid transparent;
		border-bottom: var(--yotpo-tooltip-arrow-size) solid transparent;
		box-shadow: var(--yotpo-tooltip-shadow);
	}

	.overlay__positioner[data-popper-placement='right-start'] .tooltip:after {
		top: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	.overlay__positioner[data-popper-placement='right-end'] .tooltip:after {
		top: auto;
		bottom: var(--yotpo-tooltip-arrow-start-end-offset);
	}

	.tooltip__prefix,
	.tooltip__suffix {
		display: flex;
		align-items: center;
		font-size: var(--yotpo-tooltip-icon-font-size);
	}

	.action-text {
		font-size: var(--yotpo-tooltip-font-size);
		font-weight: var(--yotpo-tooltip-font-weight);
		line-height: var(--yotpo-tooltip-line-height);
		color: var(--yotpo-tooltip-color-link);
		text-decoration: none;
		cursor: pointer;
	}

	.action-text-last-line {
		display: block;
		width: fit-content;
		text-align: start;
	}

	.tooltip__message {
		display: flex;
		flex-direction: column;
	}

	.tooltip--has-prefix .tooltip__message {
		padding-left: var(--yotpo-tooltip-icon-spacing);
	}

	.tooltip--has-suffix .tooltip__message {
		padding-right: var(--yotpo-tooltip-icon-spacing);
	}

	.tooltip__title {
		white-space: pre-wrap;
	}

	.tooltip__text {
		display: table;
	}
`;

// src/components/tooltip/tooltip.ts
var YotpoTooltip = class extends OverlayComponent {
  constructor() {
    super(...arguments);
    this.hasPrefix = false;
    this.hasSuffix = false;
    this.text = "";
    this.tooltipTitle = "";
    this.tooltipPlacement = "top" /* top */;
    this.tipPlacement = "center" /* center */;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("role", "tooltip");
    this.distance = 9;
    this.possibleSlots = ["prefix", "suffix"];
    this.updateComplete.then(() => this.handlePlacementChange());
  }
  getOverlayPlacement() {
    return this.tooltipPlacement + (this.tipPlacement !== "center" /* center */ ? "-" + this.tipPlacement : "");
  }
  handlePlacementChange() {
    this.placement = this.getOverlayPlacement();
  }
  handleContentChange() {
    this.updateOverlayContent();
  }
  handleSlotChange() {
    this.hasPrefix = hasSlot(this, "prefix");
    this.hasSuffix = hasSlot(this, "suffix");
    this.updateOverlayContent();
  }
  handleClick(event) {
    event.stopPropagation();
  }
  handleActionTextClicked(actionText) {
    emit(this, "yotpo-tooltip-action" /* tooltipAction */, { detail: actionText });
  }
  render() {
    return this.renderOverlay(html`
			<div
				part="base"
				data-cy="tooltip-content"
				id="tooltip"
				class=${classMap({
      tooltip: true,
      "tooltip--has-prefix": this.hasPrefix,
      "tooltip--has-suffix": this.hasSuffix
    })}
				role="tooltip"
				@click=${this.handleClick}
			>
				<div class="tooltip__inner">
					<span part="prefix" class="tooltip__prefix">
						<slot @slotchange=${this.handleSlotChange} name="prefix"></slot>
					</span>
					<span part="message" class="tooltip__message yotpo-theme-dark">
						${this.tooltipTitle ? html`<span part="title" class="yotpo-text-small yotpo-text-primary yotpo-text-bold">
									<div class="tooltip__title">${this.tooltipTitle}</div>
							  </span>` : ""}
						<span part="text" class="tooltip__text yotpo-text-primary yotpo-text-small">
							${actionTextConversion(this.text, this.handleActionTextClicked.bind(this))}
						</span>
					</span>
					<span part="suffix" class="tooltip__suffix">
						<slot @slotchange=${this.handleSlotChange} name="suffix"></slot>
					</span>
				</div>
			</div>
		`);
  }
};
YotpoTooltip.styles = tooltip_styles_default;
__decorateClass([
  query(".tooltip")
], YotpoTooltip.prototype, "tooltip", 2);
__decorateClass([
  state()
], YotpoTooltip.prototype, "hasPrefix", 2);
__decorateClass([
  state()
], YotpoTooltip.prototype, "hasSuffix", 2);
__decorateClass([
  property({ reflect: true })
], YotpoTooltip.prototype, "text", 2);
__decorateClass([
  property({ reflect: true })
], YotpoTooltip.prototype, "tooltipTitle", 2);
__decorateClass([
  property({ reflect: true })
], YotpoTooltip.prototype, "tooltipPlacement", 2);
__decorateClass([
  property({ reflect: true })
], YotpoTooltip.prototype, "tipPlacement", 2);
__decorateClass([
  watch("tooltipPlacement", { waitUntilFirstUpdate: true }),
  watch("tipPlacement", { waitUntilFirstUpdate: true })
], YotpoTooltip.prototype, "handlePlacementChange", 1);
__decorateClass([
  watch("text", { waitUntilFirstUpdate: true }),
  watch("tooltipTitle", { waitUntilFirstUpdate: true })
], YotpoTooltip.prototype, "handleContentChange", 1);
YotpoTooltip = __decorateClass([
  customElement("yotpo-tooltip")
], YotpoTooltip);

export {
  YotpoTooltip
};
